export const NATIONALITIES = [
    { value: "1", label: "Brasileiro(a)" },
    { value: "2", label: "Afegão(ã)" },
    { value: "3", label: "Albanês(a)" },
    { value: "4", label: "Alemão(ã)" },
    { value: "5", label: "Americano(a)" },
    { value: "6", label: "Angolano(a)" },
    { value: "7", label: "Argentino(a)" },
    { value: "8", label: "Argelino(a)" },
    { value: "9", label: "Australiano(a)" },
    { value: "10", label: "Austríaco(a)" },
    { value: "11", label: "Belga" },
    { value: "12", label: "Boliviano(a)" },
    { value: "13", label: "Britânico(a)" },
    { value: "14", label: "Búlgaro(a)" },
    { value: "15", label: "Camaronês(a)" },
    { value: "16", label: "Canadense" },
    { value: "17", label: "Chileno(a)" },
    { value: "18", label: "Chinês(a)" },
    { value: "19", label: "Colombiano(a)" },
    { value: "20", label: "Congolês(a)" },
    { value: "21", label: "Coreano(a)" },
    { value: "22", label: "Costa-riquenho(a)" },
    { value: "23", label: "Croata" },
    { value: "24", label: "Cubano(a)" },
    { value: "25", label: "Dinamarquês(a)" },
    { value: "26", label: "Dominicano(a)" },
    { value: "27", label: "Equatoriano(a)" },
    { value: "28", label: "Egípcio(a)" },
    { value: "29", label: "Espanhol(a)" },
    { value: "30", label: "Etíope" },
    { value: "31", label: "Filipino(a)" },
    { value: "32", label: "Finlandês(a)" },
    { value: "33", label: "Francês(a)" },
    { value: "34", label: "Ganês(a)" },
    { value: "35", label: "Grego(a)" },
    { value: "36", label: "Guatemalteco(a)" },
    { value: "37", label: "Guianense" },
    { value: "38", label: "Haitiano(a)" },
    { value: "39", label: "Holandês(a)" },
    { value: "40", label: "Hondurenho(a)" },
    { value: "41", label: "Húngaro(a)" },
    { value: "42", label: "Indiano(a)" },
    { value: "43", label: "Indonésio(a)" },
    { value: "44", label: "Iraniano(a)" },
    { value: "45", label: "Iraquiano(a)" },
    { value: "46", label: "Irlandês(a)" },
    { value: "47", label: "Israelense" },
    { value: "48", label: "Italiano(a)" },
    { value: "49", label: "Jamaicano(a)" },
    { value: "50", label: "Japonês(a)" },
    { value: "51", label: "Jordaniano(a)" },
    { value: "52", label: "Libanês(a)" },
    { value: "53", label: "Malaio(a)" },
    { value: "54", label: "Marroquino(a)" },
    { value: "55", label: "Mexicano(a)" },
    { value: "56", label: "Moçambicano(a)" },
    { value: "57", label: "Nicaraguense" },
    { value: "58", label: "Nigeriano(a)" },
    { value: "59", label: "Norueguês(a)" },
    { value: "60", label: "Neozelandês(a)" },
    { value: "61", label: "Panamenho(a)" },
    { value: "62", label: "Paquistanês(a)" },
    { value: "63", label: "Paraguaio(a)" },
    { value: "64", label: "Peruano(a)" },
    { value: "65", label: "Polonês(a)" },
    { value: "66", label: "Português(a)" },
    { value: "67", label: "Romeno(a)" },
    { value: "68", label: "Russo(a)" },
    { value: "69", label: "Salvadorenho(a)" },
    { value: "70", label: "Sérvio(a)" },
    { value: "71", label: "Singapurense" },
    { value: "72", label: "Sírio(a)" },
    { value: "73", label: "Sueco(a)" },
    { value: "74", label: "Suíço(a)" },
    { value: "75", label: "Sul-africano(a)" },
    { value: "76", label: "Surinamês(a)" },
    { value: "77", label: "Tailandês(a)" },
    { value: "78", label: "Taiwanês(a)" },
    { value: "79", label: "Turco(a)" },
    { value: "80", label: "Ucraniano(a)" },
    { value: "81", label: "Uruguaio(a)" },
    { value: "82", label: "Venezuelano(a)" },
    { value: "83", label: "Vietnamita" },
    { value: "99", label: "Outra" },
];
